import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import {
  Step,
  Stepper,
  StepLabel,
} from 'material-ui/Stepper';
import { closeModal as closeMassDialog } from './store/actions';
import { openUpgradeFrom } from '../../stores/ui/components/upgrade/upgrade-actions';

const styles = {
  header: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 16px 0 16px',
  },
  title: {
    flexBasis: '50%',
  },
  stepper: {
  },
  summaryText: {
    fontSize: '11px',
    lineHeight: '20px',
    '& > a': {
      cursor: 'pointer',
    },
  },
};

class MassMessageDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { currentStep, classes, companyPlan } = this.props;
    return (<div className={classes.header}>
      <div className={classes.title}>
        <h3>Compose New Message</h3>
        { (companyPlan === 'basic') ? <div className={classes.summaryText}>
          You can send a bulk message to up to 20 partners on the Basic Plan.<br />
          To message up to 200 partners <a onTouchTap={() => {
            this.props.openUpgradeFrom('massMessaging');
            this.props.closeMassDialog();
            // this.props.dispatch({ type: 'TRACK_EVENT', payload: { name: '[App Bar] Upgrade Click' } });
          }}
          > upgrade to the Connected Plan</a>.
        </div> : <div className={classes.summaryText}>
          You can send a bulk message to up to 200 partners on the Connected Plan.
        </div> }
      </div>
      <div className={classes.stepper}>
        <Stepper activeStep={currentStep}>
          <Step>
            <StepLabel>Add Partners</StepLabel>
          </Step>
          <Step>
            <StepLabel>Subject & Content</StepLabel>
          </Step>
        </Stepper>
      </div>
    </div>);
  }
}

MassMessageDialog.propTypes = {
  classes: PropTypes.object,
  closeMassDialog: PropTypes.func,
  companyPlan: PropTypes.string,
  currentStep: PropTypes.number,
  openUpgradeFrom: PropTypes.func,
};

const mapStateToProps = ({ user }) => ({
  companyPlan: user.getIn(['company', 'plan']),
});

export default connect(mapStateToProps, {
  closeMassDialog,
  openUpgradeFrom,
})(injectSheet(styles)(MassMessageDialog));



// WEBPACK FOOTER //
// ./src/app/components/massmessaging/title.jsx